
import axios, { AxiosError, AxiosInstance } from 'axios';
import ErrorResponse from './../../../src/error-response';

import * as ServerData from './../../server-data';

export default class FreshworksWriterService {

   public static addCreditorNotes(
           axiosInstance: AxiosInstance, input: ServerData.FreshworksWebWriter.AddCreditorNotes$Input,
           f: (output: string) => void,
           eh: ((error: AxiosError) => void)|undefined)  {
        const theEh = (eh === undefined) ?  ((error: AxiosError) => {ErrorResponse.handle(error); }) : eh;
        const config = {
            data : input.toJson()

         };
        return axiosInstance.post(
            'spineapi/freshworks/add-creditor-notes',
            input.toJson()
        ).then((response) => response.data as string)
       .then((output) => f(output))
       .catch(theEh);
   }


   public static addNote(
           axiosInstance: AxiosInstance, input: ServerData.FreshworksWebWriter.AddNote$Input,
           f: (output: ServerData.FreshworksWebWriter.AddNote$Output) => void,
           eh: ((error: AxiosError) => void)|undefined)  {
        const theEh = (eh === undefined) ?  ((error: AxiosError) => {ErrorResponse.handle(error); }) : eh;
        const config = {
            data : input.toJson()

         };
        return axiosInstance.post(
            'spineapi/freshworks/add-note',
            input.toJson()
        ).then((response) => ServerData.FreshworksWebWriter.AddNote$Output.fromJson(response.data))
       .then((output) => f(output))
       .catch(theEh);
   }


}

